module.exports = __webpack_public_path__ + "img/lv15.8a2e1526.png";